export const sessionCustomerIdKey = 'customerId';
export const sessionOfficerIdKey = 'officeId';
export const sessionOfficerNameKey = 'officeName';